// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkbox-primary label[data-v-6afc6fb0] {\n  margin-left: 2em;\n}\n.checkbox-primary input[type=checkbox]:checked + label[data-v-6afc6fb0]::before {\n  border-color: #2196f3;\n  background-color: #2196f3;\n}", ""]);
// Exports
module.exports = exports;
